'use strict';

let isDashboardEditModeOn = false;
let unsubscribeFromSidebarClosing = () => {};

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.EditDashboardController', [
	'$stateParams',
	'mx.shell.SidebarService',
	'mx.shell.View',
	'mx.shell.NavigationManager',
	'mx.SolutionBuilderAgent.DashboardWidgetDataService',
	'mx.internationalization',
	'mx.shell.NavigationService',
	'mx.shell.EventService',
	function editDashboardCtrl($stateParams, sidebarService, MxView, navigationManager, dashboardDataService, internationalization, navigationService, eventService) {
		let dashboardId = '';

		const navigationId = ($stateParams.navigationId || '').toLowerCase();

		navigationService.getNavigationItem(navigationId).then(function (navigationItem) {
			if (navigationItem) {
				dashboardId = (navigationItem.contentWidgetId || '').toLowerCase();

				if (sidebarService.isOpened) {
					stopEditDashboard();
				} else {
					beginEditDashboard();
				}
			}
		});

		function stopEditDashboard(closedBySideBarClosingEvent) {
			isDashboardEditModeOn = false;
			unsubscribeFromSidebarClosing();
			if (!closedBySideBarClosingEvent) {
				sidebarService.close();
			}
			dashboardDataService.disableDashboardEditMode(dashboardId);
			navigationManager.collapsedMode = false;
		}

		function beginEditDashboard() {
			isDashboardEditModeOn = true;
			const dashboardEditView = new MxView({
				id: '__dashboard_editor_view__',
				name: internationalization.get('solutionBuilderAgent.components.mx-dashboard-editor.dashboard-editor'),
				locals: { dashboardId: dashboardId },
				controller: function () {},
				template: '<mx-dashboard-editor dashboard-id="{{vm.dashboardId}}"></mx-dashboard-editor>',
			});

			sidebarService.open(dashboardEditView);
			dashboardDataService.enableDashboardEditMode(dashboardId);
			navigationManager.collapsedMode = true;

			unsubscribeFromSidebarClosing = eventService.subscribeOnce(mx.shell.EventCodes.SidebarClosed, () => {
				if (isDashboardEditModeOn) {
					stopEditDashboard(true);
				}
			});
		}
	},
]);
